import { Injectable, signal } from '@angular/core';
import _ from 'lodash';
import { TranslateService } from '@ngx-translate/core';
import { tournamentStages } from '../utils/enums/tournament-stages';
import { tournamentPhases } from '../utils/enums/tournament-phases';
import { Option } from '../models/option';
import { tournamentDivisions } from '../utils/enums/tournament-divisions';
import { tournamentMaxTeams } from '../utils/enums/tournament-max-teams';
import { tournamentStatus } from '../utils/enums/tournament-status';
import { binaryOptions } from '../enums/binary';
import { LogService } from './log.service';

@Injectable({
  providedIn: 'root'
})
export class AuxiliarService {
  public searchField = signal<string>('');

  constructor(
    private logService: LogService,
    private translate: TranslateService,
  ) { }

  // set search filter
  public setSearchFilter(value: string) {
    this.searchField.set(_.toLower(_.deburr(value)));
  }

  // copy text to clipboard
  public copyToClipboard(txt: any): void {
    navigator.clipboard.writeText(txt).then(() => {
      this.logService.info('-', '-', this.translate.instant('success.copy'));
    });
  }

  // get binary options (yes/no)
  public getBinaryOptions(): Option[] {
    return _.map(binaryOptions, (option) => {
      return {...option, name: this.translate.instant(option.name)};
    });
  }

  // get tournament (current) stage options
  public getTournamentStageOptions(): Option[] {
    return _.map(tournamentStages, (option) => {
      return {...option, name: this.translate.instant(`tournament-stages.${option.name}`)};
    });
  }

  // get tournament status options
  public getTournamentStatusOptions(): Option[] {
    return _.map(tournamentStatus, (option) => {
      return {...option, name: this.translate.instant(`status.${option.name}`)};
    });
  }

  // get tournament phases options
  public getTournamentPhaseOptions(): Option[] {
    return _.map(tournamentPhases, (option) => {
      return {...option, name: this.translate.instant(`tournament-phases.${option.name}`)};
    });
  }

  // get tournament playoffs phase options
  public getTournamentPlayoffsPhaseOptions(): Option[] {
    return _.map(_.filter(tournamentPhases, {playoffs: true}), (option) => {
      return {...option, name: this.translate.instant(`tournament-phases.${option.name}`)};
    });
  }

  // get tournament division options
  public getTournamentDivisionOptions(): Option[] {
    return _.map(tournamentDivisions, (option) => {
      return {...option, name: this.translate.instant(`tournament-divisions.${option.name}`)};
    });
  }

  // get tournament max teams options
  public getTournamentMaxTeamsOptions(): Option[] {
    return _.map(tournamentMaxTeams, (option) => {
      return {...option, name: `${option.value} ${_.toLower(this.translate.instant('field.teams'))}`};
    });
  }
}
